import { TypographyOptions } from "@material-ui/core/styles/createTypography";

const typography: TypographyOptions = {
  fontFamily: [
    "Roboto",
    "-apple-system",
    "Inter",
    "BlinkMacSystemFont",
    '"Segoe UI"',
    '"Helvetica Neue"',
    "Arial",
    "sans-serif",
    '"Apple Color Emoji"',
    '"Segoe UI Emoji"',
    '"Segoe UI Symbol"',
  ].join(","),
  fontSize: 13,
  fontWeightLight: 300,
  fontWeightRegular: 400,
  fontWeightMedium: 500,
  fontWeightBold: 600,
  h1: {
    fontSize: "2rem",
    fontWeight: 400,
    lineHeight: "40px",
  },
  h2: {
    fontSize: "1.5rem",
    fontWeight: 700,
    lineHeight: "32px",
  },
  h3: {
    fontSize: "1.5rem",
    fontWeight: 600,
    lineHeight: 1.25,
  },
  h4: {
    fontSize: "1.125rem",
    fontWeight: 500,
    lineHeight: 1.25,
  },
  h5: {
    fontSize: "1.0625rem",
    fontWeight: 500,
    lineHeight: 1.25,
  },
  h6: {
    fontSize: "1rem",
    fontWeight: 500,
    lineHeight: 1.25,
  },
  body1: {
    fontSize: 14,
    color: "#000000",
  },
  body2: {
    fontSize: 12,
  },
  subtitle1: {
    fontSize: 18,
    fontWeight: 400,
    lineHeight: "24px",
    color: "#000000",
  },
  subtitle2: {
    fontSize: 16,
    lineHeight: 1.25,
  },
  button: {
    height: "40px",
    textTransform: "none",
  },
};

export default typography;
